// 1～23までの配列生成（代勤、スポットの時間設定に使用）
export const HOURS = Array.from({ length: 23 }, (_, i) => i);

// 15分刻みの分
export const MINUTES15 =  [ '00', '15', '30', '45' ];

// 1分刻みの分
export const MINUTES1 = Array.from({ length: 60 }, (_, i) => i);